import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    mapProp: 'algMap',
    name: '算法',
    type: 'SF_ALG',
}
